<template>
  <ul class="list-group">
    <li
      v-for="lesson in lessons"
      :key="lesson.id"
      class="list-group-item d-flex justify-content-between align-items-center cursor-pointer"
      :class="{
        'text-muted': lesson.status == 0,
        'active-item': lesson.id == lessonIdSelected,
      }"
      :title="lesson.description"
      @click="$emit('detailsLesson', lesson.id)"
    >
      <p class="flex-1 mb-0">
        <i
          class="me-1"
          :class="{
            'ph-monitor-play': lesson.type === '1',
            'ph-list-bullets': lesson.type === '2',
            'ph-file-text': lesson.type === '3',
          }"
        />
        {{ lesson.title }}
      </p>
      <span class="badge bg-primary" title="Detalhes">Detalhes</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListLessons',

  props: {
    lessons: {
      type: Array,
      required: true,
    },
    lessonIdSelected: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.flex-1 {
  flex: 1;
}

.active-item {
  color: #333;
  text-decoration: none;
  background-color: #eee;
}
</style>
